module.exports = __webpack_public_path__ + "img/10-2.f882c6d9.png";